export enum StyleVariantType {
    FilledFilled = 'filled-filled',
    ClearFilled = 'clear-filled',
    ClearClear = 'clear-clear',
}
